import React from 'react';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';

const UsersTitle = ({ accounts }) => {
  const inviteesCount = accounts.filter(({ isPending }) => isPending).length;
  return (
    <Flex gap='1rem' items='center' justify='center' height='100%'>
      <Text size='large' weight='500'>
        {accounts.length - inviteesCount} USERS
      </Text>
      {!!inviteesCount && (
        <>
          <Text size='x-large' color='silverSand' weight='400'>
            |
          </Text>
          <Text size='x-medium' color='shuttleGray' weight='400'>
            {inviteesCount} invited
          </Text>
        </>
      )}
    </Flex>
  );
};

export default UsersTitle;
